import { Slider, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { set_card_policy } from "../../actions/cards/cards";
import usePayAxios from "../../config/useAxios";
import { apis } from "../../config/APIs";
import { cardsDetails } from "./../../actions/cards/cards";

const PosLimitComponent = ({ card_id, card_ref_number, txnEnable }) => {
  const [limits, setLimits] = useState({});
  const dispatch = useDispatch();
  
  const { onCall, data } = usePayAxios({
    api: apis.get_card_limit_per_txn,
    method: "post",
  });
  // Get card details from Redux
  const cardsDetailsResponse = useSelector((state) => state.cards.cardsDetails);

  const setCardLimit = useSelector((state) => state.cards.set_card_policy);
   const cardLimit = data?.response ? data?.response : [];
  //const cardLimit = cardsDetailsResponse?.data?.response?.card_details?.data?.card_limits || [];
  const handleSliderChange = (channelType, type, value, maxLimit) => {
    if (value <= maxLimit) {
      setLimits((vals) => ({
        ...limits,
        [channelType]: {
          ...vals[channelType],
          [type]: value,
        },
      }));
    }
  };

    useEffect(() => {
    // Detect POS switch toggle
    // This will run whenever txnEnable.POS changes
    // You can also check for other switches (ATM, ECOM, CTLS)
    // Example: fetch limits when POS is enabled/disabled
    if (typeof txnEnable?.POS !== "undefined" || typeof txnEnable?.CTLS !== "undefined" || typeof txnEnable?.ATM !== "undefined" || typeof txnEnable?.ECOM !== "undefined") {
      // Do something, e.g., call API or update state
      // console.log("POS switch toggled:", txnEnable.POS);
      onCall({
        data: {
          card: { card_id },
        },
      });
    }
  }, [txnEnable.POS,txnEnable.CTLS,txnEnable.ATM,txnEnable.ECOM, card_id]);

    useEffect(() => {
    if (card_id) {
      dispatch(cardsDetails({ card_id }));
    }
  }, [card_id, dispatch]);

  useEffect(() => {
    if (card_id)
      onCall({
        data: {
          card: { card_id },
        },
      });
  }, [card_id]);

  React.useEffect(() => {
    if (setCardLimit?.success && !setCardLimit?.data?.errors) {
      onCall({
        data: {
          card: { card_id },
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setCardLimit]);

  useEffect(() => {
    if (cardLimit?.length) {
      setLimits(
        cardLimit?.reduce((acc, channel) => {
          acc[channel.channelType] = {
            txn: channel.transactionLimit,
          };
          return acc;
        }, {})
      );
    }
  }, [cardLimit]);

  const callPolicy = (transaction_type, amount, frequency) => {
    dispatch(
      set_card_policy({
        card: {
          card_id,
          channel_and_limit: {
            [transaction_type]: amount,
          },
        },
      })
    );
  };

  const renderSliders = (item) => (
    <div className="slider-comp">
      {/* Daily Limit */}
      <div className="slider-item">
        <label>Single Transaction Limit</label>
        <div
          className="slider"
          style={{ display: "flex", alignItems: "center", gap: "10px" }}
        >
          <span className="min">INR {limits[item?.channelType]?.txn}</span>
          <Slider
            min={0}
            max={item?.maxTransactionLimit}
            step={100}
            value={limits[item?.channelType]?.txn}
            onChange={(value) =>
              handleSliderChange(
                item?.channelType,
                "txn",
                value,
                item?.maxTransactionLimit
              )
            }
            style={{ flex: 1 }}
            tooltip={{ formatter: (val) => val }}
          />
          <span className="max">
            INR {item?.maxTransactionLimit} <span>(Max Limit)</span>
          </span>
        </div>
        
      </div>
      {item?.transactionLimit !== limits?.[item?.channelType]?.txn && (
          <button
            className="primary-btn"
            style={{
              height: 40,
              display: "flex",
              alignItems: "center",
              fontSize: "0.9rem",
              fontWeight: 500,
              padding: "0.5rem 1rem",
              marginLeft: 10,
              width: 60,
            }}
            onClick={() => {
              callPolicy(item?.channelType, limits[item?.channelType]?.txn);
            }}
            disabled={setCardLimit?.loading}
          >
            {setCardLimit?.loading ? "Saving..." : "Save"}
          </button>
        )}
    </div>
  );

  return (
    <div className="limits-tabs" style={{ padding: "20px" }}>
      <Tabs defaultActiveKey="pos">
        <Tabs.TabPane tab="POS" key="pos">
          {renderSliders(cardLimit?.find((ele) => ele?.channelType === "POS"))}
        </Tabs.TabPane>
        <Tabs.TabPane tab="ATM withdrawal" key="atm">
          {renderSliders(cardLimit?.find((ele) => ele?.channelType === "ATM"))}
        </Tabs.TabPane>
        <Tabs.TabPane tab="Online Transactions" key="online">
          {renderSliders(cardLimit?.find((ele) => ele?.channelType === "ECOM"))}
        </Tabs.TabPane>
        <Tabs.TabPane tab="Contactless" key="contactless">
          {renderSliders(cardLimit?.find((ele) => ele?.channelType === "CTLS"))}
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
};

export default PosLimitComponent;
